import { createReducer } from "@reduxjs/toolkit";
import {
  deleteMixesSuccess,
  getCompletedMixListSuccess,
  getMixesListSuccess,
  getProductMixListSuccess,
  LoadingData,
  loadingList,
  saveMixesListSuccess,
  setProcedureId,
} from "./mixesActions";

export interface IMixesState {
  mixesList: Array<any>;
  dataCount: number;
  isLoading: boolean;
  completedMixList: Array<any>;
  ProcedureId: number;
  productsMixesList: Array<any>;
}

const initialState: IMixesState = {
  mixesList: [],
  dataCount: 0,
  isLoading: false,
  completedMixList: [],
  ProcedureId: 0,
  productsMixesList: [],
};

export const mixesReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(LoadingData, (state, action) => {
      state = {
        ...state,
        isLoading: action.payload,
      };
      return state;
    })
    .addCase(getMixesListSuccess, (state, action) => {
      state = {
        ...state,
        mixesList: action.payload?.data,
        dataCount: action.payload?.dataCount,
      };
      return state;
    })
    .addCase(getProductMixListSuccess, (state, action) => {
      state = {
        ...state,
        productsMixesList: action.payload?.data,
        dataCount: action.payload?.dataCount,
      };
      return state;
    })
    .addCase(saveMixesListSuccess, (state, action) => {
      state = {
        ...state,
        mixesList: action.payload,
      };
      return state;
    })

    .addCase(loadingList, (state, action) => {
      state = {
        ...state,
        isLoading: action.payload,
      };
      return state;
    })

    .addCase(deleteMixesSuccess, (state, action) => {
      const filteredList = state.mixesList.filter(
        (item) => !action.payload.includes(item.id),
      );
      return {
        ...state,
        mixesList: filteredList,
      };
    })
    .addCase(getCompletedMixListSuccess, (state, action) => {
      state = {
        ...state,
        completedMixList: action.payload?.data,
        dataCount: action.payload?.dataCount,
      };
      return state;
    })
    .addCase(setProcedureId, (state, action) => {
      state = {
        ...state,
        ProcedureId: action.payload,
      };
      return state;
    });
});
